import { Skeleton, Stack } from "@mui/material";
import { type ReactNode } from "react";

import { ShiftCardWrapper } from "../../Shift/Card/Wrapper";
import { VisitCardContentWrapper } from "./ContentWrapper";

export interface InHomeVisitCardSkeletonProps {
  children?: ReactNode;
  loadingLabel?: string;
}

export function InHomeVisitCardSkeleton(props: InHomeVisitCardSkeletonProps) {
  const { children, loadingLabel } = props;

  return (
    <ShiftCardWrapper sx={{ flexGrow: 1 }} role="progressbar" aria-label={loadingLabel}>
      <VisitCardContentWrapper>
        <Stack spacing={6} direction="column">
          <Stack direction="row" spacing={4} alignItems="flex-start">
            <Skeleton variant="rounded" width={48} height={48} />
            <Stack spacing={1} sx={{ flexGrow: 1 }}>
              <Skeleton variant="text" width="40%" height="1.25rem" />
              <Skeleton variant="text" width="60%" height="1.25rem" />
              <Skeleton variant="text" width="40%" height="1.25rem" />
              <Skeleton variant="text" width="75%" height="1.25rem" />
            </Stack>
          </Stack>

          {children ?? <Skeleton variant="text" width="100%" height="1.5rem" />}
        </Stack>
      </VisitCardContentWrapper>
    </ShiftCardWrapper>
  );
}
